// extracted by mini-css-extract-plugin
module.exports = {"infoTrigger":"info-tooltip-trigger_infoTrigger__66a_2"};